<template>
  <div class="textBlock">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TextBlock'
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

::v-deep {
  p + p {
    margin-top: 5px;
  }

  em {
    font-style: normal;
    font-weight: bold;
  }

  a {
    color: var.$color-main-text;
  }

  & .topBorderArea {
    margin-top: 40px;
    padding-top: 30px;
    border-top: 1px solid var.$color-border-gray;

    @include mixins.media() {
      margin-top: 50px;
    }
  }

  .notes {
    font-size: 1.2rem;
    line-height: 1.5;
  }

  ul.notes {
    margin-left: 1.5em;

    & > li {
      text-indent: -1.5em;

      & + li {
        margin-top: 0.5em;
      }
    }
  }

  .notes + .notes {
    margin-top: 16px;
  }

  .block + .block {
    margin-top: 16px;
  }
}
</style>
